// Licensed under Gnu Public Licence version 2
// Copyright (c) 2020 (original work) Open Assessment Technologies SA ;

/**
 * Calculates proper number of rows and columns in grid
 * @param {number} rowNum - suggested number of rows in grid
 * @param {number} colNum - suggested number of columns in grid
 * @param {number} optionsNum - total number of elements in grid
 * @returns {{rowNum: number, colNum: number}}
 */
export default function adjustGridProps(rowNum, colNum, optionsNum = 0) {
    let rows = rowNum || 0;
    let cols = colNum || 0;

    if (rows <= 0 && cols <= 0) {
        rows = 1;
        cols = optionsNum;
    } else {
        if (cols <= 0) {
            cols = Math.ceil(optionsNum / rows);
        } else if (rows <= 0) {
            rows = Math.ceil(optionsNum / cols);
        }
    }
    return { rowNum: rows, colNum: cols };
}
